module.exports = __webpack_public_path__ + "static/assets/4a3e75a918bb16870f05d1fff7fdc7d2.gif";